// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__pCw0Q","productName":"Table_productName__19Fdm"};